import { makeStyles } from "@mui/styles";
import { Upload1 } from "../../Icons";
import { Box } from "@mui/material";


export const CustomStyles = () => {
    const useStyles = makeStyles(() => ({
        hover: {
            cursor: 'pointer',
            '&:hover': { border: '#009F4D solid 2px' },
            // whiteSpace: 'normal', // Allows text to wrap
            wordWrap: 'break-word', // Ensures long words will break
        },
        text: {
            width: "100%",
            marginBottom: '2px',
            display: "flex",
            fontWeight: 600
        },
        txtfld: {
            fontSize: '10px',
            '& label.Mui-focused': {
                color: '#009E6A',
            },
            '& .MuiOutlinedInput-root': {
                // borderRadius: '12px',
                backgroundColor: '#fff',
                '& fieldset': {
                    borderColor: '#F1F1F1',
                },
                '&:hover fieldset': {
                    borderColor: '#009E6A',
                },
                // '&.Mui-focused fieldset': {
                //     borderColor: '#009E6A',
                // },
            },
            width: "100%"
        },
        handler: {
            width: "100%",
            display: "flex",
            // justifyContent: "space-between",
            gap: "8px"
        }


    }));
    return useStyles()
}


export const UploadIcon = () => {
    return (
        <Box width="100%" display="flex" alignItems={"center"} justifyContent="center" alignContent={"center"} pt={3} gap={2}>
            <Box color="#008000" fontStyle="italic" fontWeight={550}>Change Image</Box><Upload1 fill="#008000" width={40} />
        </Box>
    )
}
export const InputIcon = () => {
    return (
        <Box width="100%" display="flex" alignItems={"center"} justifyContent="center" alignContent={"center"} pt={3} gap={2}>
            <Box color="#008000" fontStyle="italic" fontWeight={550}>Upload photo</Box><Upload1 fill="#008000" width={40} />
        </Box>
    )
}
